/**
 * Focuses on the first visible search bar in the document
 */
window.focusSearchBar = (): void => {
    const searchBars = document.querySelectorAll(".search-bar__input input") as NodeListOf<HTMLElement>;

    console.log(searchBars);

    if (!searchBars) return;

    for (const searchBar of searchBars) {
        if (isHidden(searchBar)) continue;

        window.toggleOverlay("search-results", "modal", false, searchBar);
    }
};

/**
 * Check if an element is hidden
 *
 * @param element any HTML element
 *
 * @returns Whether an element is hidden
 */
const isHidden = (element: HTMLElement): boolean => {
    return element.offsetParent === null;
};
